import { render, staticRenderFns } from "./BasicFormFields.vue?vue&type=template&id=5d501c40"
import script from "./BasicFormFields.vue?vue&type=script&lang=js"
export * from "./BasicFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports